
import { forwardRef, useEffect, useId, useState } from 'react';
import { Stack, Text } from '@client/shared/design';
import { AnchoredCard } from '@client/shared/design';
import { BlockConfirmBody, type BlockConfirmEdit } from './BlockConfirmBody.tsx';
import styles from './ListingDetails.module.css';

export interface BlockConfirmPopoverProps {
  ranges: readonly { start: string; end: string }[];
  zone: string | null;
  anchor: { x: number; y: number } | null;
  edit?: BlockConfirmEdit | null;
  busy: boolean;
  error: boolean;
  onCommit: (reason: string) => void;
  onCancel: () => void;
}

export const BlockConfirmPopover = forwardRef<HTMLDivElement, BlockConfirmPopoverProps>(
  function BlockConfirmPopover({ ranges, zone, anchor, edit, busy, error, onCommit, onCancel }, ref) {
    const [draft, setDraft] = useState('');
    const titleId = useId();

    useEffect(() => {
      const onKey = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          onCancel();
        }
      };
      document.addEventListener('keydown', onKey);
      return () => document.removeEventListener('keydown', onKey);
    }, [onCancel]);

    return (
      <AnchoredCard
        ref={ref}
        anchor={{ point: anchor }}
        className={styles.actionCard}
        gap={8}
        cardWidth={300}
        flipRoom={220}
        flipUp={220}
        role="dialog"
        aria-modal="false"
        aria-labelledby={titleId}
      >
        <Stack gap={3}>
          <Text
            id={titleId}
            as="span"
            size="xs"
            tone="muted"
            weight="semibold"
            className={styles.popoverEyebrow}
          >
            Block time
          </Text>
          <BlockConfirmBody
            ranges={ranges}
            zone={zone}
            edit={edit}
            draft={draft}
            onDraftChange={setDraft}
            busy={busy}
            conflict={error}
            onCommit={() => onCommit(draft)}
            onCancel={onCancel}
          />
        </Stack>
      </AnchoredCard>
    );
  },
);
